/*
 * Copyright (c) Nexign, JSC, 2022-2024.
 */
/**
 * @author Yakov.Gushchin
 * @author Julia Ignatieva
 * @author Ilya Baranchikov
 * @version 1.28.0
 * @since 1.0.0
 */

import { IPageHistoryInquiryTranslation } from '../../types';

const initTranslationPageHistoryInquiry: IPageHistoryInquiryTranslation = {
    tabMenu: {
        DEFAULT: '',
        OTHER: '',
    },
    table: {
        id: {
            header: '',
            placeholder: '',
        },
        inquiryNumber: {
            header: '',
        },
        account: {
            header: '',
            placeholder: '',
        },
        closeDate: {
            header: '',
        },
        createDate: {
            header: '',
        },
        description: {
            header: '',
            placeholder: '',
        },
        status: {
            header: '',
        },
        subscriberNumber: {
            header: '',
            placeholder: '',
        },
        topic: {
            header: '',
        },
        updateDate: {
            header: '',
        },
        processingReport: {
            header: '',
        },
    },
    title: {
        dropFilters: '',
        export: '',
        label: '',
    },
};

export default initTranslationPageHistoryInquiry;
